// extracted by mini-css-extract-plugin
export var avatarContainer = "_5e-1";
export var largeAvatarContainer = "_5e-2";
export var smallAvatarContainer = "_5e-0";